/* eslint-disable n/handle-callback-err */
import { useContext, createContext, useState, useEffect } from "react"

import { LogsInitContext } from "../LogsInitComponentesContext/LogsInitComponentesContext"

import { useNavigate } from "react-router-dom"

export const LogadoContext = createContext()

export const LogadoProvider = ({ children }) => {
    const { LogInit } = useContext(LogsInitContext)
    LogInit('LogadoProvider', 'contexto')

    const [logado, setLogado] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        verifyLogado()
    }, [])

    const verifyLogado = () => {
        let UserStorage = sessionStorage.getItem('o_mo_user')
        if (!UserStorage) {
            alterLogado(false)
        }

        let LogadoStorage = sessionStorage.getItem('o_mo_user_logado')
        if (LogadoStorage) {
            alterLogado(true)
        } else {
            alterLogado(false)
        }
    }

    const alterLogado = (logado) => {
        setLogado(logado)
        if (logado) {
            sessionStorage.setItem('o_mo_user_logado', true)
        } else {
            sessionStorage.removeItem('o_mo_user_logado')
            navigate('/login')
        }
    }

    let value = { logado, alterLogado, verifyLogado }

    return (
        <LogadoContext.Provider value={value}>
            <div>
                {children}
            </div>
        </LogadoContext.Provider>
    )
}
